import { getLocaleDateTimeStringUTC } from '@go-shared/lib/time';
import React, { FC } from 'react';
import { VenueRequestComment } from '../../shared/types/groupBooking';

export type GroupMessagePosition = 'left' | 'right';

export interface GroupMessageProps {
  comment: VenueRequestComment;
  position: GroupMessagePosition;
  dark?: boolean;
}

function getSenderInitials(comment: VenueRequestComment) {
  return [comment.user?.firstName, comment.user?.lastName]
    .filter((s): s is string => typeof s === 'string' && s.trim().length > 0)
    .map(s => s[0].toUpperCase())
    .join('') || '?';
}

const GroupMessage: FC<GroupMessageProps> = ({ comment, dark, position }) => {
  let addtClass = '';

  if (dark) {
    addtClass = 'bg-slate text-white';
  } else {
    addtClass = 'bg-white';
  }

  switch (comment.status) {
    case 'approved':
      addtClass = 'bg-lime-darker text-white';
      break;
    case 'rejected':
    case 'cancelled':
      addtClass = 'bg-crimson text-white';
      break;
    case 'draft':
      addtClass = 'bg-banana-dark text-white';
      break;
  }

  return (
    <div className="flex flex-col w-full">
      <div
        className={`flex relative p-2 rounded shadow
    ${position === 'right' ? 'self-end' : 'self-start'} ${addtClass}`}
        style={{ width: '80%' }}
      >
        {position === 'left' && (
          <div
            className="bg-white grid w-8 h-8 text-md mr-2 rounded-full
        items-center justify-center text-navy-darkest border shadow flex-shrink-0"
          >
            {getSenderInitials(comment)}
          </div>
        )}

        <div className="flex-grow">
          <div dangerouslySetInnerHTML={{ __html: comment.message }}></div>
          <span className="text-xxs">
            Sent: {getLocaleDateTimeStringUTC(comment.date)} by{' '}
            <strong>
              {comment.user?.firstName || comment.user?.lastName
              ? `${comment.user.firstName ?? ''} ${comment.user.lastName ?? ''}`.trim()
              : 'System'}
            </strong>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GroupMessage;
